import { Action } from 'redux';
import { IPaginationMetaResponse, IPaginationParams } from '../../libs/quickjobs-api';
import { IReview } from '../types/review';

export const REVIEWS_FETCH_REQUEST = 'REVIEWS_FETCH_REQUEST';
export const REVIEWS_FETCH_SUCCESS = 'REVIEWS_FETCH_SUCCESS';
export const REVIEWS_ERROR = 'REVIEWS_ERROR';
export const REVIEW_REMOVE_REQUEST = 'REVIEW_REMOVE_REQUEST';

export interface IReviewsFetchRequestAction extends Action {
  type: typeof REVIEWS_FETCH_REQUEST;
  payload: IPaginationParams;
}

export interface IReviewsFetchSuccessAction extends Action {
  type: typeof REVIEWS_FETCH_SUCCESS;
  payload: { reviews: IReview[]; meta: IPaginationMetaResponse };
}

export interface IReviewsErrorAction extends Action {
  type: typeof REVIEWS_ERROR;
  message: string;
}

export interface IReviewRemoveRequestAction extends Action {
  type: typeof REVIEW_REMOVE_REQUEST;
  payload: {
    id: number;
    onSuccess?: () => Action;
  };
}

export type IReviewsAction = IReviewsFetchSuccessAction | IReviewsErrorAction;

export function fetchReviewsRequest(params?: IPaginationParams): IReviewsFetchRequestAction {
  return {
    type: REVIEWS_FETCH_REQUEST,
    payload: {
      ...params,
    },
  };
}

export function fetchReviewsSuccess(
  reviews: IReview[],
  meta: IPaginationMetaResponse
): IReviewsFetchSuccessAction {
  return {
    type: REVIEWS_FETCH_SUCCESS,
    payload: {
      reviews,
      meta,
    },
  };
}

export function reviewsError(message: string): IReviewsErrorAction {
  return {
    type: REVIEWS_ERROR,
    message,
  };
}

export function removeReviewRequest(
  reviewId: number,
  onSuccess?: () => Action
): IReviewRemoveRequestAction {
  return {
    type: REVIEW_REMOVE_REQUEST,
    payload: {
      id: reviewId,
      onSuccess: onSuccess,
    },
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/reviews.ts